import React from "react";
import { IVideoPlayerProps } from "./VideoPlayerProps";
import { Container } from "./VideoPlayerHelpers";
import ReactPlayer from "react-player";
import { player } from "./VideoPlayer.module.scss";

const VideoPlayer: React.FC<IVideoPlayerProps> = (props) => {
  return (
    <Container>
      <ReactPlayer
        id="explore-sonesta-video-player"
        url={props.url}
        width={props.width}
        height={props.height}
        className={player}
      />
    </Container>
  );
};

export default VideoPlayer;
